import React from 'react';

const MediumLevelIcon = ({ colour = '#6021B3', width = '12', height = '12', style }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={style}
        >
            <path
                d="M3 9.25L6 6.25L9 9.25"
                stroke={colour}
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M3 6.25L6 3.25L9 6.25"
                stroke={colour}
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default MediumLevelIcon;
